import { AvailableIcons } from '@asn/icon';

import { Component, output, input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import '@asn/icon';

/**
 * @ngdoc component
 * @name ApIconButtonLinkComponent
 * @module ApIconButtonLinkModule
 * @description A component a link with an icon
 */
@Component({
    selector: 'ap-icon-button-link',
    templateUrl: './icon-button-link.component.html',
    styleUrls: ['./icon-button-link.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApIconButtonLinkComponent {
    /**
     * Required - The icon to display
     */
    public readonly iconName = input.required<AvailableIcons>();

    /**
     * The size of the icon. Defaults to `medium`
     */
    public readonly iconSize = input('medium');

    /**
     * Emits event on click of button
     */
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public readonly onClick = output<Event>();
}
